export default () => ({
  main: {
    id: 'main',
    name: '主文档空间',
    // The rest will be filled by the workspace/workspacesById getter
  },
});



// WEBPACK FOOTER //
// ./src/data/defaults/defaultWorkspaces.js